import {
  actionCreator,
  checkHttpStatus,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  CurriculumLibrariesActionTypes,
  GET_CURRICULUM_LIBRARIES_LIST_API,
  POST_CURRICULUM_LIBRARIES_API,
  GET_CURRICULUM_LIBRARIES_DETAILS_API,
  DELETE_CURRICULUM_LIBRARIES_API,  
  POST_UPLOADCSVDOCUMENTSFORDC,
  DOWNLOAD_SMAPLE_DOCUMENT,
  ARCHIVE_BATCH_DC_STATUS_API,
  UNARCHIVE_BATCH_DC_STATUS_API,
} from '../constants/ApiConstants';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI, downloaduploadedDocumentsOnAPICall, showWarningMessage } from '../../../../actions/utilAction';


export const getCurriculumLibrariesList = (searchObj, isAllRecordsRequired) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(CurriculumLibrariesActionTypes.get_curriculumLibrariesList.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_CURRICULUM_LIBRARIES_LIST_API}${query_params}&isAllRecordsRequired=${isAllRecordsRequired}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(  CurriculumLibrariesActionTypes.get_curriculumLibrariesList.SUCCESS, response));
        } else {
          dispatch(actionCreator(  CurriculumLibrariesActionTypes.get_curriculumLibrariesList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_curriculumLibrariesList ', error);
      });
  };
};

export const saveCurriculumLibraries = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(CurriculumLibrariesActionTypes.post_curriculumLibraries.REQUEST));
    fetch(POST_CURRICULUM_LIBRARIES_API, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(CurriculumLibrariesActionTypes.post_curriculumLibraries.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(CurriculumLibrariesActionTypes.post_curriculumLibraries.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_curriculumLibraries', error);
      });
  };
};

export const getCurriculumLibrariesDetails = (CollectionFrequencyID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(CurriculumLibrariesActionTypes.get_curriculumLibrariesDetails.REQUEST));
    fetch(`${GET_CURRICULUM_LIBRARIES_DETAILS_API}?curriculumLibraryId=${CollectionFrequencyID}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(CurriculumLibrariesActionTypes.get_curriculumLibrariesDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(CurriculumLibrariesActionTypes.get_curriculumLibrariesDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_curriculumLibrariesDetails ', error);
      });
  };
};

export const deleteCurriculumLibraries = (CollectionFrequencyID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(CurriculumLibrariesActionTypes.delete_curriculumLibraries.REQUEST));
    fetch(`${DELETE_CURRICULUM_LIBRARIES_API}?curriculumLibraryId=${CollectionFrequencyID}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode === 200 || response.statusCode === 204) { 
          showSuccessMessage(response.message);
          dispatch(actionCreator(CurriculumLibrariesActionTypes.delete_curriculumLibraries.SUCCESS, response));
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(CurriculumLibrariesActionTypes.delete_curriculumLibraries.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(CurriculumLibrariesActionTypes.delete_curriculumLibraries.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error delete_curriculumLibraries', error);
      });
  };
};

export const UpdateDCArchiveStatus = (Ids,status,actionName,patientId = 0) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(CurriculumLibrariesActionTypes.archive_batchDCStatus.REQUEST));
    fetch(`${ARCHIVE_BATCH_DC_STATUS_API}?ids=${Ids}&status=${status}&actionName=${actionName}&patientId=${patientId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(CurriculumLibrariesActionTypes.archive_batchDCStatus.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(CurriculumLibrariesActionTypes.archive_batchDCStatus.SUCCESS, null));          
        }
      })
      .catch(function (error) {
        console.log('error delete_BatchAppliedPayments', error);
      });
  };
};

export const UpdateDCBatchUnarchiveStatus = (Ids,status,actionName) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(CurriculumLibrariesActionTypes.archive_batchDCStatus.REQUEST));
    fetch(`${UNARCHIVE_BATCH_DC_STATUS_API}?ids=${Ids}&status=${status}&actionName=${actionName}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(CurriculumLibrariesActionTypes.archive_batchDCStatus.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(CurriculumLibrariesActionTypes.archive_batchDCStatus.SUCCESS, null));          
        }
      })
      .catch(function (error) {
        console.log('error delete_BatchAppliedPayments', error);
      });
  };
};

// Document Upload
export const UploadCSVDocument = (UploadFile) => {  
 return (dispatch, getState) => {
   dispatch(actionCreator(CurriculumLibrariesActionTypes.post_UploadCSVDocumentsForDC.REQUEST));
   fetch(`${POST_UPLOADCSVDOCUMENTSFORDC}`, {
     method: 'post',
     headers: jsonApiHeader(getState().login.access_token, 'application/json'),
     body: JSON.stringify(UploadFile),
   })
     .then(checkHttpStatus)
     .then(function(response) {        
       if (response.statusCode === 200) {
         showSuccessMessage(response.message);
       } else if (response.statusCode === 422) {
         showWarningMessage(response.message);
       } else {
         dispatch(actionCreator(CurriculumLibrariesActionTypes.post_UploadCSVDocumentsForDC.FAILURE, response.message));
         //showErrorMessage(response.message);
       }
       let searchObj = {
        sort_fields: '',
        sort_order: '',
        contain_filters: { SearchText: null },
        pageNumber:1,
      };
      dispatch(getCurriculumLibrariesList(searchObj));      
     })
     .catch(function(error) {
       console.log('error-----', error);
     });
 };
};

// Sample Document Download
export const downloadSampleLibraryDocument = (fileName) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(CurriculumLibrariesActionTypes.download_sample_document.REQUEST));
    fetch(`${DOWNLOAD_SMAPLE_DOCUMENT}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    }).then(function(response) {
      dispatch(actionCreator(CurriculumLibrariesActionTypes.download_sample_document.SUCCESS));
      return response.blob();
    }).then(function(blob) {
      downloaduploadedDocumentsOnAPICall(blob, fileName);
    });
  };
};


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/actions/CurriculumLibrariesActions.js